import React, { FC } from 'react';

import { Button, EElementSize, Panel } from '@kapital-bank/kb-ui-design-system';

import { useGeneralInfoContext } from 'shared/context/WithGeneralInfo/GeneralInfoContext';
import { LoanCalculationData, LoanOffer } from 'shared/model';
import { translate } from 'shared/utils/translation';

import './index.scss';

interface IProps {
  duration?: number;
  setDuration?: (value: number) => void;
  scoringData: LoanCalculationData;
  setPeriods: (value: LoanOffer[]) => void;
}

const Months: FC<IProps> = ({ duration, setDuration, scoringData, setPeriods }) => {
  const { channelType } = useGeneralInfoContext();
  const { orderOffers } = scoringData.calculator;

  const handleMonthSelect = (month: string) => {
    setDuration?.(parseInt(month, 10));
    setPeriods(orderOffers[month]);
  };

  const monthButtons = Object.keys(orderOffers).map(month => {
    const isSelected = month === duration?.toString();
    const className = isSelected ? `months_selected-${channelType}` : `months-btn__${channelType}`;

    return (
      <Button key={month} className={className} onClick={() => handleMonthSelect(month)} size={EElementSize.MD}>
        {month}
      </Button>
    );
  });

  return (
    <Panel className="credit-month">
      <Panel className="credit-month__label">
        <span>
          {translate('common.credit.term')} ({translate('common.month')?.toUpperCase()})
        </span>
      </Panel>
      <Panel
        justifyContent={0}
        alignItems={2}
        className={`months 
        ${Object.values(orderOffers).length > 4 ? 'credit-month-many' : ''} 
        ${Object.values(orderOffers).length === 4 ? 'credit-month-four' : ''}
            `}
      >
        {monthButtons}
      </Panel>
    </Panel>
  );
};

export default Months;
